<template>
  <div class="def-main">
    <div class="def-top">

      <div class="row">
        <div class="col-12">
          <img class="pt-5 pl-10 pr-3" style="height: 70px;" :src="'/assets/img/logo-'+ (optimaTheme !== 'dark' ? 'normal' : 'purple-bg') + '.png'">

        </div>
      </div>

      <div class="row">
        <div class="col-12 text-center optima-theme-topbar">
          <div v-if="optimaTheme === 'dark'">Healthy Events</div>
        </div>
      </div>

      <v-app-bar color="#3a3a3a" dark flat app v-if="user">
        <v-toolbar-title>Optima Events App</v-toolbar-title>
        <v-spacer style="z-index: 1"></v-spacer>
        <v-toolbar-items>
          <v-btn color="#fff" text to="/">Home</v-btn>
          <v-btn color="#fff" text to="/company" v-if="isAdminRole"
            >Company</v-btn
          >
          <v-btn color="#fff" text to="/operations" v-if="isAdminRole"
            >Operations</v-btn
          >
          <v-btn color="#fff" text to="/templates" v-if="isAdminRole"
            >Comms Templates</v-btn
          >
          <v-btn color="#fff" text to="/email-extractor" v-if="isAdminRole"
            >Email Extractor</v-btn
          >
          <v-btn
            color="#fff"
            text
            to="/events"
            v-if="isAdminRole"
            style="margin-right: 55px"
            >Events</v-btn
          >
          <v-btn
            color="#fff"
            text
            to="/consultant"
            v-else-if="isConsultantRole"
            style="margin-right: 55px"
            >Consultant</v-btn
          >
          <v-speed-dial
            style="right: 20px; top: 10px"
            fixed
            v-model="fab"
            :direction="direction"
            :open-on-hover="hover"
            :transition="transition"
          >
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab small>
                <v-icon v-if="fab">mdi-close</v-icon>
                <v-icon v-else>mdi-account-circle</v-icon>
              </v-btn>
            </template>

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn fab dark small color="green" to="/profile" v-on="on">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Update profile</span>
            </v-tooltip>

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn
                  fab
                  dark
                  small
                  color="orange"
                  to="/changepassword"
                  v-on="on"
                >
                  <v-icon>mdi-lock-open-outline</v-icon>
                </v-btn>
              </template>
              <span>Change password</span>
            </v-tooltip>

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn fab dark small color="indigo" to="/users" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Add user</span>
            </v-tooltip>

            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn fab dark small color="red" @click="onSignOut()" v-on="on">
                  <v-icon>exit_to_app</v-icon>
                </v-btn>
              </template>
              <span>Logout</span>
            </v-tooltip>
          </v-speed-dial>
        </v-toolbar-items>
      </v-app-bar>
    </div>
    <v-main>
      <slot />
    </v-main>
    <div class="def-bottom my-3">
      <div class="row optima-theme-bottombar">
        <div class="col-6">
          <div style="display: flex; flex-direction: row;">
            <div style="display: flex; flex-direction: column;" class="py-3 pr-3 pl-10">
              <strong>Policies:</strong>
              <a href="/downloads/terms-of-usage.pdf" target="_blank">Terms Of Use</a>
              <a href="/downloads/privacy-policy.pdf" target="_blank">Privacy Policy</a>
            </div>
            <div style="display: flex; flex-direction: column;" class="pa-3">
              <strong>Contact Us:</strong>
              <a href="mailto:Wellbeing.team@optimahealth.co.uk">Wellbeing.team@optimahealth.co.uk</a>
              0800 170 1777
            </div>
          </div>
        </div>
        <div class="col-6">
          <div style="display: flex; flex-direction: row; justify-content: flex-end; align-items: center;height: 100%;">
            <span class="pa-3">2017 - 2025 Optima Health</span>
            <img class="py-3 pl-3 pr-10" style="height: 70px;" :src="'/assets/img/logo-'+ (optimaTheme === 'dark' ? 'normal' : 'purple-bg') + '.png'">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  methods: {
    async onSignOut() {
      await this.$store.dispatch("logout");
      this.$router.push("/");
    },
  },
  props: ['optimaTheme'],
  data: () => ({
    direction: "bottom",
    hover: false,
    transition: "slide-y-reverse-transition",
    fab: false,
    isValidOperations: false,
    isConsultantRole: false,
    isAdminRole: false,
  }),
  async created() {
    const that = this;
    if (this.$store.getters.roles) {
      this.$store.getters.roles.forEach(function(role) {
        const accessRoles = ["ADMIN", "SERVICE", "DELIVERY"];
        if (accessRoles.includes(role)) {
          that.isConsultantRole = true;
        }
        const powerUserRole = ["ADMIN", "SERVICE"];
        if (powerUserRole.includes(role)) {
          that.isAdminRole = true;
        }
      });
    }
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
};
</script>
